var React = require('react');

function Ground (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"be93b756-97b2-4690-88e6-bb97c4e5d977","data-name":"Calque 2"},React.createElement("g",{"id":"a2936793-912d-4ba4-b4c0-e32e7bf57f8c","data-name":"Calque 1"},[React.createElement("rect",{"y":"1212.25","width":"1498.85","height":"333.5","style":{"fill":"#d47362"},"key":0}),React.createElement("rect",{"x":"423.29","y":"571.45","width":"1075.56","height":"333.5","style":{"fill":"#d47362"},"key":1}),React.createElement("rect",{"x":"5617.35","y":"843.84","width":"2021.17","height":"333.5","transform":"translate(5617.35 7638.52) rotate(-90)","style":{"fill":"#d47362"},"key":2}),React.createElement("rect",{"x":"4966.12","y":"1164.17","width":"1964.89","height":"333.5","transform":"translate(4617.65 7279.48) rotate(-90)","style":{"fill":"#d47362"},"key":3})])));
}

Ground.defaultProps = {"viewBox":"0 0 6794.68 2313.36"};

module.exports = Ground;

Ground.default = Ground;
